import { useMemo } from 'react';
import { usePortsGetList } from '@ais-ui/api';
import { PortList } from '@ais-ui/api-spec/portserver';

interface UsePortsFilterProps {
  searchString: string;
  maxResults?: number;
}

interface UsePortsFilterReturn {
  filteredPorts: PortList[];
  allPorts: PortList[];
  isLoading: boolean;
  error: any;
}

export function usePortsFilter({
  searchString,
  maxResults = 150,
}: UsePortsFilterProps): UsePortsFilterReturn {
  const { data, isLoading, error } = usePortsGetList();

  const allPorts = useMemo(() => {
    return data?.records ?? [];
  }, [data]);

  const filteredPorts = useMemo(() => {
    if (!searchString || searchString.length < 3) {
      return [];
    }

    const filtered = allPorts.filter(
      (port) =>
        port.name?.toLowerCase().includes(searchString.toLowerCase()) ||
        port.locode?.toLowerCase().includes(searchString.toLowerCase()) ||
        port.country?.toLowerCase().includes(searchString.toLowerCase())
    );

    return filtered.slice(0, maxResults);
  }, [allPorts, searchString, maxResults]);

  return {
    filteredPorts,
    allPorts,
    isLoading,
    error,
  };
}
